 <!-- HR处理离职列表 -->
<template>
  <div class="mod-sys__dimission">
    <!-- 查询条件：处理状态 姓名 职位 离职时间-->
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm">
        <el-row class="margb10">
          <!-- 处理状态 -->
          <el-col :span="6"
                  class="padt5">
            <el-form-item :label="$t('dimission.dimissionStatus')">
              <el-select v-model="dataForm.dimissionStatus"
                         :placeholder="$t('dimission.dimissionStatus')"
                         clearable>
                <el-option v-for="(item,index) in dimissionStatusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 姓名 -->
          <el-col :span="6"
                  class="padt5">
            <el-form-item :label="$t('dimission.name')">
              <el-input v-model="dataForm.userName"
                        type="text"
                        :placeholder="$t('dimission.name')"
                        clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 职位 -->
          <el-col :span="6"
                  class="padt5">
            <el-form-item :label="$t('dimission.jobCode')">
              <el-select v-model="dataForm.jobCode"
                         :placeholder="$t('dimission.jobCode')"
                         clearable
                         filterable>
                <el-option v-for="(item,index) in positionList"
                           :key="index"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         @click="getDataListMerge()"
                         type="primary">{{ $t('query') }}</el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="resetModify()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <div v-show="isShow">
          <el-row class="margb10">
            <!-- 离职时间起止 -->
            <el-col :span="10"
                    class="padt5">
              <el-form-item :label="$t('dimission.dimissionDate')"
                            style="width: 100%!important;">
                <el-date-picker v-model="dataForm.dimissionDateModify"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                :start-placeholder="$t('dimission.startData')"
                                :end-placeholder="$t('dimission.endData')"
                                :clearable="true"
                                :editable='false'
                                style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <!-- 表头:序号 姓名 用户类型 性别 工作年限 宝龄 职位 学历 加入网点日期 离职时间 是否加入人才库 处理状态 -->
      <el-table :data="dataList"
                border
                v-loading="dataListLoading"
                style="width: 100%;">
        <!-- 序号 -->
        <!-- <el-table-column prop="dimissionId"
                         align="center"
                         fixed="left"
                         :label="$t('dimission.dimissionId')"
                         show-overflow-tooltip>
        </el-table-column> -->
        <el-table-column type="index"
                         align="center"
                         fixed
                         width="60"
                         :label="$t('dimission.dimissionId')"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 姓名 user_name -->
        <el-table-column prop="userName"
                         align="center"
                         :label="$t('dimission.name')"
                         show-overflow-tooltip
                         fixed
                         width="150">
          <template slot-scope="scope">
            <span class="el-dropdown-link"
                  role="button"
                  tabindex="0"
                  v-if="$hasPermission('AUTH000055')"
                  @click="goUserCheck(scope.row.userId)">
              {{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <!-- 用户类型 org_type -->
        <el-table-column prop="orgType"
                         align="center"
                         :label="$t('dimission.userType')"
                         :formatter="orgFormatter"
                         show-overflow-tooltip
                         width="130">
        </el-table-column>
        <!-- 性别 sex_code -->
        <el-table-column prop="sexCode"
                         align="center"
                         :label="$t('dimission.sexCode')"
                         :formatter="sexFormatter"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 处理状态 dimission_status -->
        <el-table-column prop="dimissionStatus"
                         align="center"
                         :label="$t('dimission.dimissionStatus')"
                         :formatter="dimissionStatusFormatter"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 工作年限 计算 1年一下 1~3年 3~5年 5~10年 10年以上 当前时间减去离校时间 -->
        <!-- <el-table-column prop="workingYears"
                         align="center"
                         :label="$t('dimission.workingYears')"
                         show-overflow-tooltip>
        </el-table-column> -->
        <!-- 宝龄 单独计算，宝马工龄累计（bmw_seniority）+ 当前时间 - 入职时间（TODO需要跟许确认当前算法） -->
        <el-table-column prop="bmwSeniority"
                         align="center"
                         width="100"
                         :label="$t('dimission.bmwSeniority')"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 职位 job_code -->
        <el-table-column prop="positionName"
                         align="center"
                         :label="$t('dimission.jobCode')"
                         show-overflow-tooltip
                         width="150">
        </el-table-column>
        <!-- 学历 education_code -->
        <el-table-column prop="educationCode"
                         align="center"
                         :label="$t('dimission.educationCode')"
                         :formatter="educationFormatter"
                         show-overflow-tooltip>
        </el-table-column>
        <!-- 加入网点日期 org_join_date -->
        <el-table-column prop="orgJoinDate"
                         align="center"
                         :label="$t('dimission.orgJoinDate')"
                         :formatter="joinDateFormatter"
                         show-overflow-tooltip
                         width="120">
        </el-table-column>
        <!-- 离职时间 dimission_date -->
        <el-table-column prop="dimissionDate"
                         align="center"
                         :label="$t('dimission.dimissionDate')"
                         :formatter="dimissionDateFormatter"
                         show-overflow-tooltip
                         width="120">
        </el-table-column>
        <!-- 是否加入人才库 talent_bank_flag -->
        <el-table-column prop="recommendFlag"
                         align="center"
                         width="130"
                         :label="$t('dimission.talentBankFlag')"
                         :formatter="configFormatter"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.recommendFlag == '10'">{{$t('user.yes')}}</span>
            <!-- 不活动 -->
            <span v-if="scope.row.recommendFlag == '20'">{{$t('user.no')}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         width="100"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <el-dropdown trigger="click"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- 反馈 -->
                <el-dropdown-item @click.native="gotoView('process', scope.row)"
                                  v-if="scope.row.dimissionStatus === '10' && $hasPermission('AUTH000052')">{{ $t('dealWith') }}</el-dropdown-item>
                <!-- 查看 -->
                <el-dropdown-item @click.native="gotoView('view', scope.row)"
                                  v-if="scope.row.dimissionStatus !== '10' && $hasPermission('AUTH000053')">查看</el-dropdown-item>
                <!-- 离职记录 -->
                <!-- <el-dropdown-item v-if="$hasPermission('AUTH000054')"
                                  @click.native="gotoViewHistory(scope.row.userId)">离职历史记录</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle"
                     :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
      <dimission-history v-if="DimissionHistory"
                         ref="DimissionHistory"></dimission-history>
    </el-card>
  </div>
</template>

<script>
// import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
import ToggleDiv from '@/components/toggle-div'
import DimissionHistory from './dimission-history'
import AesUtil from "@/utils/aes_utils";
export default {
  // mixins: [mixinViewModule],
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/dimission/list',
        getDataListIsPage: true
      },
      dataForm: { // 查询条件
        dimissionStatus: '',
        userName: '',
        jobCode: '',
        dimissionDateModify: '',
        dimissionDateStart: '',
        dimissionDateEnd: ''
      },
      dimissionStatusArr: _this.enums['dimissionStatus'], // 处理状态
      positionList: [], // 职位
      dataList: [], // 列表数据
      dataListLoading: false,
      isShow: false, // 展开更多
      DimissionHistory: false,
      page: 1,
      limit: 10,
      total: 0
    }
  },
  components: {
    ToggleDiv,
    DimissionHistory
  },
  methods: {
    // 性别
    sexFormatter(row) {
      return Vue.filter('coverEnum')(row.sexCode, 'sex')
    },
    // 处理状态
    dimissionStatusFormatter(row) {
      return Vue.filter('coverEnum')(row.dimissionStatus, 'dimissionStatus')
    },
    // 是否加入人才库
    configFormatter(row) {
      return Vue.filter('coverEnum')(row.talentBankFlag, 'confirmState')
    },
    // 用户类型
    orgFormatter(row) {
      return Vue.filter('coverEnum')(row.orgType, 'userType') + '用户'
    },
    // 学历
    educationFormatter(row) {
      return Vue.filter('coverEnum')(row.educationCode, 'educationCode')
    },
    // 格式化时间没有时分秒
    joinDateFormatter(row) {
      if (row.orgJoinDate !== '' && row.orgJoinDate) {
        return Vue.filter('formatDateNoTime')(row.orgJoinDate)
      } else {
        return ''
      }
    },
    // 格式化时间没有时分秒
    dimissionDateFormatter(row) {
      if (row.dimissionDate !== '' && row.dimissionDate) {
        return Vue.filter('formatDateNoTime')(row.dimissionDate)
      } else {
        return ''
      }
    },
    // 查看离职历史记录
    gotoViewHistory(id) {
      this.DimissionHistory = true
      this.$nextTick(() => {
        this.$refs.DimissionHistory.init(id)
      })
    },
    resetModify() {
      this.page = 1
      this.dataForm = {
        dimissionStatus: '',
        userName: '',
        jobCode: '',
        dimissionDateModify: '',
        dimissionDateStart: '',
        dimissionDateEnd: ''
      }
      this.getDataList()
    },
    getDataListMerge() {
      this.page = 1
      if (this.dataForm.dimissionDateModify !== '' && this.dataForm.dimissionDateModify) {
        if (this.dataForm.dimissionDateModify.length === 2) {
          this.dataForm.dimissionDateStart = this.dataForm.dimissionDateModify[0]
          this.dataForm.dimissionDateEnd = this.dataForm.dimissionDateModify[1]
        }
      } else {
        this.dataForm.dimissionDateStart = ''
        this.dataForm.dimissionDateEnd = ''
      }
      this.getDataList()
    },
    // 操作列下拉选项
    gotoView(type, row) {
      if (type === 'process') {
        let businessKey = ''
        if (row.version) {
          businessKey = 'dimission-' + row.dimissionId + '-' + row.version
        } else {
          businessKey = 'dimission-' + row.dimissionId
        }
        this.$request.getAct(`/act/operate/taskInfoByBusinessKey/${businessKey}`).then((res, total, code, data) => {
          if (res.code === '3') {
            this.$alert('当前离职流程不存在审批任务').then(
              this.reset()
            )
            return false
          } else {
            let query = {
              taskId: res.taskId,
              processId: res.processInstanceId,
              type: 'dimission',
              approval: 1,
              businessEntrance: 'dimission', // 如果不从待办页面进入离职页面，则返回离职列表
              dimissionId: row.dimissionId
            }
            this.$router.push({
              name: 'task-import-dimission',
              query: query
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      } else if (type === 'view') {
        this.$router.push({
          name: 'activiti-dimission-view',
          query: {
            dimissionId: row.dimissionId,
            buttonShow: 'dimission'
          }
        })
      }
    },
    // 展开更多
    toggle(data) {
      this.isShow = data
    },
    // 获取职位
    getPosition() {
      this.$request.get(`/sys/commuser/commPosition`).then((res) => {
        this.positionList = res
      }).catch((err) => {
        console.log(err)
      })
    },
    // 跳转用户查看页面
    goUserCheck(userId) {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userid = base64url.encode(aes.encrypt(userId + ''))
      this.$router.push({
        name: 'sys-check',
        query: {
          userId: userid,
          dimission: 'dimission'
        }
      })
    },
    // 获取数据列表
    getDataList() {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.result
        this.dataList = JSON.parse(JSON.stringify(resultList))
        let todayTime = new Date().getTime()
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].dimissionStatus === '30') {
            this.dataList[i].bmwSeniority = (this.dataList[i].bmwSeniority / 365).toFixed(2)
          } else {
            if (this.dataList[i].currentVersionDate) {
              let newdate = (todayTime - (new Date(Date.parse(this.dataList[i].currentVersionDate.replace(/-/g, '/'))).getTime())) / 1000 / 60 / 60 / 24
              this.dataList[i].bmwSeniority = ((Number(this.dataList[i].bmwSeniority) + Number(newdate)) / 365).toFixed(2)
            }
          }
        }
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.total : 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1
      this.limit = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val
      this.getDataList()
    }
  },
  mounted() {
    this.getPosition()
  },
  activated() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.padt5 {
  text-align: left;
}
</style>
